import React from 'react';
import { Home, Compass, ShoppingCart, Headphones, User } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

export const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { count: cartCount } = useCart();

  const navItems = [
    { icon: Home, label: 'Home', path: '/', onClick: () => navigate('/') },
    { icon: Compass, label: 'Explore', path: '/explore', onClick: () => navigate('/explore') },
    { icon: ShoppingCart, label: 'Cart', path: '/cart', onClick: () => navigate('/cart'), badge: cartCount },
    { icon: Headphones, label: 'Support', path: '/support', onClick: () => navigate('/support') },
    { icon: User, label: 'Profile', path: '/profile', onClick: () => navigate('/profile') },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-2 py-2 flex justify-around items-center z-50 shadow-lg md:hidden">
      {navItems.map(({ icon: Icon, label, path, onClick, badge }) => {
        const isActive = location.pathname === path;
        return (
          <button
            key={path}
            onClick={onClick}
            aria-label={`${label}${badge ? `, ${badge} items` : ''}`}
            className={`relative flex flex-col items-center gap-1 p-2 rounded-xl transition-all duration-300 ${
              isActive ? 'bg-primary bg-opacity-10 scale-110' : 'hover:bg-gray-100'
            }`}
          >
            {badge ? (
              <span className="absolute top-0 right-0.5 min-w-[18px] h-[18px] bg-indigo-600 rounded-full flex items-center justify-center text-white text-[10px] font-bold shadow-sm px-1">
                {badge > 9 ? '9+' : badge}
              </span>
            ) : null}
            <Icon
              size={24}
              className={`transition-colors duration-300 ${
                isActive ? 'text-primary' : 'text-gray-400'
              }`}
            />
            <span className={`text-xs transition-colors duration-300 ${
              isActive ? 'text-primary font-semibold' : 'text-gray-400'
            }`}>
              {label}
            </span>
          </button>
        );
      })}
    </nav>
  );
};